export const bunkeringKeyTitles = {
  "BNK_IMO No.": { title: "IMO No.", unit: "" },
  BNK_Vessel: { title: "Vessel Name", unit: "" },
  BNK_TunkerNumber: { title: "Tanker Number", unit: "" },
  BNK_Port: { title: "Port", unit: "" },
  BNK_VesselSignature: { title: "Vessel Signature", unit: "" },

  BNK_ActFuelType: { title: "Fuel Type", unit: "" },
  BNK_ACT_DensityMeanValue: { title: "Density", unit: "kg/l" },
  BNK_ACT_Density15MeanValue: { title: "Density @15°C", unit: "kg/l" },
  BNK_ACT_FlowMeanValue: { title: "Flow Rate", unit: "m³/h" },
  BNK_ActVolumeFlowMeanValue: { title: "Mass Flow", unit: "Tn" },

  BNK_Totaldiff: { title: "Total Mass", unit: "Tn" },
  BNK_Totaldiff_Volume: { title: "Total Volume", unit: "m³" },
  BNK_FuelMassQuantiy: { title: "Fuel Mass Quantity", unit: "kg" },

  BNK_ACT_TemperatureMeanValue: { title: "Temperature", unit: "°C" },
};

export function buildLiveBunkeringData(
  liveData,
  ship,
  neededTags = bunkeringNeededTags
) {
  const latestRecord = liveData?.[ship]?.data?.latestRecord || {};
  const latest = {};

  neededTags.forEach((tag) => {
    if (!tag) return;
    latest[tag] = latestRecord[tag] ?? null;
  });

  return {
    latestRecord: latest,
    averageRecord: {},
  };
}

export const bunkeringNeededTags = [
  "BNK_ACT_TemperatureMeanValue",
  "BNK_ACT_FlowMeanValue",
  "BNK_ActVolumeFlowMeanValue",
  "BNK_Totaldiff",
  "BNK_Totaldiff_Volume",
  "BNK_IMO No.",
  "BNK_Vessel",
  "BNK_Port",
  "BNK_VesselSignature",
  "BNK_TunkerNumber",
  "BNK_ActFuelType",
  "BNK_FuelMassQuantiy",
  "BNK_ACT_DensityMeanValue",
  "BNK_ACT_Density15MeanValue",
  "BNK_TimeStampFinish",
  "BNK_TimeStampStart",
];

const bunkeringTags = {
  averageTags: [
    "BNK_ACT_TemperatureMeanValue",
    "BNK_ACT_FlowMeanValue",
    "BNK_ActVolumeFlowMeanValue",
  ],
  latestTags: [
    "BNK_ACT_TemperatureMeanValue",
    "BNK_ACT_FlowMeanValue",
    "BNK_ActVolumeFlowMeanValue",
    "BNK_Totaldiff",
    "BNK_Totaldiff_Volume",
    "BNK_IMO No.",
    "BNK_Vessel",
    "BNK_Port",
    "BNK_VesselSignature",
    "BNK_TunkerNumber",
    "BNK_ActFuelType",
    "BNK_FuelMassQuantiy",
    "BNK_ACT_DensityMeanValue",
    "BNK_ACT_Density15MeanValue",
  ],
  endTimestamp: "BNK_TimeStampFinish",
  startTimestamp: "BNK_TimeStampStart",
  resetTag: "BNK_ResetTotalizer",
};

export default bunkeringTags;
